import { css } from 'styled-components'

export default css`
  &.MileageMap {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
  }
`
